import React, { useState } from "react";
import * as XLSX from "xlsx";

// Import custom scripts that are defined for each module
import modifyUsers from "../../soap_scripts/usermodify_passwordupdate.js";

const PasswordUpdateProcessor = ({ soapCredentials }) => {
  const [fileData, setFileData] = useState(null);
  const [progress, setProgress] = useState([]); // Track progress messages
  const [loading, setLoading] = useState(false); // Loading state

  //Function to handle submit
  const handleImport = (event) => {
    event.preventDefault();
    const fileUrl = './federationID_template.xlsx';
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'federationID_template.xlsx';
    link.click();
  };

  // Function to handle file upload and reading
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Store the workbook
      setFileData(workbook);
      console.log("Workbook data:", workbook);
    };

    reader.readAsArrayBuffer(file);
  };

  // Function to run the script based on the sheet data
  const processSheetData = async () => {
    if (!fileData) {
      alert("Please upload a file first.");
      return;
    }

    setLoading(true); // Start loading state
    setProgress([]); // Reset progress messages

    try {
      const sheets = fileData.SheetNames; // Get all sheet names
      console.log("Sheets:", sheets);
      if (!sheets || sheets.length === 0) {
        console.log("No sheets found in the workbook.");
      }

      // Define an exclusion list for sheet names
      const exclusionList = [];

      // Loop through each sheet and process accordingly
      for (const sheetName of sheets) {
        const sheet = fileData.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
        const columnNames = jsonData[0];
        const dataRows = jsonData.slice(1);
        var rowIndex;

        const formattedData = dataRows.map((row, rowIndex) => {
          let obj = {};
          columnNames.forEach((col, index) => {
            obj[col] = row[index]; // Map each column name to its corresponding value
          });
          return obj;
        });

        //console.log("Object : ", obj);
        console.log(`Formatted data from sheet ${sheetName}:`, formattedData);

        // Check if the sheet name is in the exclusion list
        if (exclusionList.includes(sheetName)) {
          //console.log("Skipping all Documentation only Sheets");
          //setProgress(prev => [...prev, `Skipping all Documentation only Sheets`]);
          continue; // Skip to the next iteration of the loop
        }

        // Switch based on the sheet name
        switch (sheetName) {
          case "Users":
            for (const data of formattedData) {
              console.log("Users Sheet ", data);
              // Skip rows with no data
              if (
                Object.values(data).every(
                  (value) =>
                    value === null || value === undefined || value === ""
                )
              ) {
                continue; // Skip empty rows
              }
              // Check for required fields
              if (
                !data["Username"] ||
                data["Username"].trim() === ""
              ) {
                console.error("Error: Missing required data for Users:", data);
                setProgress((prev) => [
                  ...prev,
                  `Error: Missing required data for Users: ${JSON.stringify(
                    data
                  )}`,
                ]);
                continue; // Move to the next row if there's missing data
              }

              try {
                // Call the createUsers function
                console.log("Call ModifyUsers Function");
                await modifyUsers(
                  {
                    username: data["Username"]
                  },
                  soapCredentials.username,
                  soapCredentials.password,
                  setProgress,
                  sheetName,
                  rowIndex
                );
              } catch (error) {
                console.log("Users error : ", error);
              }
            }
            break;
            
          default:
            console.log(`No handler for sheet ${sheetName}`);
            setProgress((prev) => [
              ...prev,
              `No handler for sheet: ${sheetName}`,
            ]);
            break;
        }
      }
    } catch (error) {
      console.error("Error making script calls:", error);
      setProgress((prev) => [
        ...prev,
        `Error making script calls: ${error.message}`,
      ]);
    } finally {
      setLoading(false); // End loading state
    }
  };

  return (
    <div>
      <h1>Federation ID Import Tool</h1>
      <strong>
        Before proceeding with the upload, make sure you are using the template
      </strong>
        <button className="submit-btn" onClick={handleImport}>
          Download Federation ID Import Template
        </button>

      <ul>
      <p>Processing with credentials:</p>
            <li><strong>Username: {soapCredentials.username}</strong></li>
            <li><strong>Password: {soapCredentials.password}</strong></li>
            <li><input type="file" accept=".xlsx, .xls" onChange={handleFileUpload} /></li>
            <li><button onClick={processSheetData} disabled={loading}>
        Run Script
      </button></li>
      </ul>

      {loading && <p>Loading... Please wait.</p>}

      <div>
        <h2>Progress:</h2>
        <ul>
          {progress.map((msg, index) => (
            <li key={index}>{msg}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PasswordUpdateProcessor;
